module.exports = __webpack_public_path__ + "img/shop_on.5d50b0ea.svg";